import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { breakpoints } from '../../../theme';
import colors from '../../../theme/colors';

export const LayoutContainer = styled(Grid)`
  display: flex;
  margin: 0;
  min-height: 100vh;
  flex-direction: row-reverse;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 1440px;
  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    flex-direction: column;
  }
`;

export const SideGraphicDiv = styled(Grid) <{ background: string }>`
  flex: 1;
  width: 100%;
  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    display: none;
  }
  position: relative;
  ${({ background, theme }) => `
    background-image: url(${background});
    background-position-x: center;
    background-repeat: no-repeat;
    background-attachment: initial;
    background-size: cover;
    background-position-y: bottom;
    background-color: ${theme.colors.white};
  `}
`;

export const ContentDiv = styled(Grid)`
  flex: 1;
  flex-grow: 1;
  position: relative;
  max-width: 1440px;
  min-height: 100vh;
`;

export const InnerContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  box-sizing: border-box;
  flex-grow: 1;

  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    justify-content: flex-start;
    height: auto;
    padding: 0 24px;
  }
`;

export const LogoContainer = styled('div')`
  background-color: ${colors.secondary.shades.shade50};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 100%;
`;

export const Logo = styled('img')``;
